import {DataRow} from "./DataRow";
import {ViewerParameters} from './ViewerParameters';

export class EnrichedDataRow extends DataRow {
  public doppler: number;
  public earthMarsDistance: number;

  public timeSinceJ2000: number;
  public timeSinceMissionStart: number;
  public timeInYears: number;
  public earthAverageAnomaly: number;
  public marsAverageAnomaly: number;
  public earthPositionX: number;
  public earthPositionY: number;
  public marsPositionX: number;
  public marsPositionY: number;
}
